var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFootLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 106,
    viewBox: "0 0 98 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14211_90127)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14211_90127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 106
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_14211_90127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.53878 81.917H0V104.85H1.53878H2.78094H13.1075V102.227H2.78094V93.7082H12.4493V91.0941H2.78094V84.5403H13.1075V81.917H2.78094H1.53878Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7796 83.3631C32.0554 82.399 30.0809 81.917 27.8469 81.917H20.9688V104.85H27.8469C30.0717 104.85 32.0554 104.368 33.7796 103.414C35.5038 102.45 36.8572 101.115 37.8398 99.3998C38.8224 97.6849 39.3137 95.6826 39.3137 93.3837C39.3137 91.0848 38.8224 89.0825 37.8398 87.3676C36.8572 85.6527 35.5038 84.3179 33.7796 83.3538V83.3631ZM35.9116 96.9897C35.4945 98.065 34.9105 98.9734 34.1411 99.7243C33.381 100.475 32.4633 101.059 31.388 101.458C30.3127 101.866 29.1354 102.06 27.8469 102.06H23.7497V84.6979H27.8469C29.1354 84.6979 30.3127 84.9019 31.388 85.3005C32.454 85.7083 33.3717 86.2831 34.1411 87.0339C34.9105 87.7848 35.4945 88.7025 35.9116 89.7685C36.3288 90.8345 36.5327 92.0396 36.5327 93.3744C36.5327 94.7093 36.3288 95.9051 35.9116 96.9804V96.9897Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.9723 81.917H46.1914V104.85H48.9723V81.917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.5283 98.9827L57.166 80.7676V104.85H59.947V87.7848L77.3185 106V81.917H74.5283V98.9827Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2148 81.917V84.5403H89.1104V104.85H91.8914V84.5403H97.7869V81.917H83.2148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5366 67.3821V33.7884C15.5366 15.1098 30.6464 0 49.223 0C67.7997 0 82.9094 15.1098 82.9094 33.6864C82.9094 52.2631 67.9016 67.2616 49.4269 67.3728H49.3435H15.5273L15.5366 67.3821ZM48.3331 65.5837V34.5856H17.3257V65.5837H48.3238H48.3331ZM50.1315 65.5559C60.6341 65.2593 70.2747 59.8272 76.0127 50.9838H50.1315V65.5559ZM77.0973 49.1855C79.5816 44.736 80.9628 39.6932 81.1111 34.5856H50.1222V49.1855H77.088H77.0973ZM81.1111 32.7872C80.6198 15.6845 66.3536 1.79834 49.223 1.79834C32.0924 1.79834 17.8262 15.6845 17.3535 32.7965H81.0925L81.1111 32.7872Z",
    fill: "black"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14211_90127)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.103516,
    y: 0.0478516,
    width: 99.3149,
    height: 107.65,
    fill: "#BDBDBD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14211_90127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.787,
    height: 106,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_14211_90127"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97.787,
    height: 106,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootLogo);
export default __webpack_public_path__ + "static/media/footLogo.45ca155f482a06fcba855b03c5da7a33.svg";
export { ForwardRef as ReactComponent };